export const SUCCESS_STATUS = "SUCCESS";
export const ERROR_STATUS = "ERROR";
export const SUCCESS_TITLE = "Success";
export const ERROR_TITLE = "Error";
export const ADD_MODE = "ADD";
export const EDIT_MODE = "EDIT";
export const TIME_FORMAT = "hh:mm A";
export const DATE_FORMAT_DMY_SLASH = "DD/MM/YYYY";
export const DATE_FORMAT_DMY_HYPHEN = "DD-MM-YYYY";
export const FORM_NAME_COMPONENT_DETAILS_ADMISSION = "component_details_admission";
export const SAVE_SUCCESS_MSG = "Data saved successfully"; 
export const UPDATE_SUCCESS_MSG = "Data updated successfully"; 
export const DEFAULT_MASTER_DRAWER_WIDTH = "700px"; 
export const LARGE_MASTER_DRAWER_WIDTH = "900px"; 
export const EXTRAA_LARGE_MASTER_DRAWER_WIDTH = "1100px"; 

export const ROUND_OFF_ACCOUNT_ID = 30; 
export const MEMBER_ACCOUNT_ID = 23; 
export const SHORT_EXCESS_ACCOUNT_ID = 31; 
export const BANK_CHARGES_ACCOUNT_ID = 57; 

export const HP_PROGRAM_ID = 1; 
export const TAP_PROGRAM_ID = 2; 
export const JCP_PROGRAM_ID = 3; 
export const PF_PROGRAM_ID = 4; 
export const GYM_PROGRAM_ID = 5; 
export const JHP_PROGRAM_ID = 6; 

export const TAP_BOOKING_CREDIT_ACCOUNT_ID = 41; 
export const TAP_BOOKING_SPECIAL_COACHING_CREDIT_ACCOUNT_ID = 44; 
export const TAP_MEMBERSHIP_ADMISSION_CREDIT_ACCOUNT_ID = 27; 
export const AFFILIATION_FEE_CREDIT_ACCOUNT_ID = 75; 

export const GYM_COACHING_FEE_ACCOUNT_ID = 43; 

export const CGST_ID_9_PERCENT = 5; 
export const SGST_ID_9_PERCENT = 6; 



export const HIGH_PERFORMANCE_TAG = "HP"; 
export const TAP_TAG = "TAP"; 
export const JCP_PROGRAM_TAG = "JCP"; 
export const PF_TAG = "PF"; 
export const GYM_TAG = "GYM"; 
export const JUNIOR_HIGH_PERFORMANCE_TAG = "JHP"; 

export const CONTRA_VOUCHER_TAG = "CN"; 
export const JOURNAL_VOUCHER_TAG = "JV"; 
export const GENERAL_VOUCHER_TAG = "GN"; 


export const DR_TAG = "Dr"; 
export const CR_TAG = "Cr"; 

export const REQUIRED_FIELD_ERROR = "The required fields must be filled out correctly"; 
export const TRY_AGAIN_ERROR = "There is some error.Try again later"; 
export const SERVER_ERROR = "There is some error from server end.Try again later"; 
export const ADD_ONE_PAYMENT_MODE = "Add at least one payment mode"; 
export const ADD_TIME_SLOT_ERROR = "Add at least one time slot"; 
export const PAYMENT_SECTION_REQUIRED_MESSAGE = "Payment Mode , Amount is required and make sure amount is greater than or equal to 0"; 
export const PAYMENT_SECTION_REQUIRED_MESSAGE_WITH_AMOUNT = "Payment Mode , Amount is required and make sure amount is greater than 0"; 
export const TIME_SLOT_REQUIRED = "Add atleast one time schedule"; 

export const GREEN_TAG = "#0A9919"; 
export const RED_TAG = "#FB6340"; 


export const CLUB_FESS = 500; 

